import { render } from "./walletUser.vue?vue&type=template&id=8ccfc0f0&scoped=true"
import script from "./walletUser.vue?vue&type=script&lang=js"
export * from "./walletUser.vue?vue&type=script&lang=js"

import "./walletUser.vue?vue&type=style&index=0&id=8ccfc0f0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ccfc0f0"]])

export default __exports__